import { Specialty } from '@dreryk/egabinet-discharge-summary-frontend-api';
import { MedicalField } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import {
   createLiteralSchema,
   createNumberSchema,
   createObjectSchema,
   createStringSchema,
   createUnionSchema,
} from '@dreryk/react-draft';

import { icd9ProcedureSchema } from '../../../shared/schemas/icd9ProcedureSchema';
import { diagnosisSchema } from '../../../shared/schemas/diagnosisSchema';

import { DischargeSummaryFormBean } from './DischargeSummaryForm/DischargeSummaryForm.types';

const specialtySchema = createObjectSchema<Specialty>({
   code: createStringSchema(),
   name: createStringSchema(),
   id: createNumberSchema(),
});

const furtherMedicalTreatmentGuidelinesSchema = createUnionSchema([
   createLiteralSchema('SPECIALIST_CARE_NEEDED'),
   createLiteralSchema('SPECIALIST_CARE_NOT_NEEDED'),
   createLiteralSchema('REFERRAL_FOR_HOSPITALIZATION_ISSUED'),
]);

const medicalDepartmentSchema = createObjectSchema<MedicalField>({
   code: createStringSchema(),
   name: createStringSchema(),
   id: createNumberSchema(),
});

export const dischargeSummaryDraftSchema = createObjectSchema<DischargeSummaryFormBean>({
   specialty: specialtySchema.nullable(),
   diagnosticsGuidelines: createStringSchema().nullable(),
   providedMedicalServiceDescription: createStringSchema().nullable(),
   otherGuidelines: createStringSchema().nullable(),
   pharmacotherapyGuidelines: createStringSchema().nullable(),
   furtherMedicalTreatmentGuidelines: furtherMedicalTreatmentGuidelinesSchema.nullable(),
   procedurePerformed: icd9ProcedureSchema.nullable(),
   diagnosis: diagnosisSchema.nullable(),
   medicalDepartment: medicalDepartmentSchema.nullable(),
});
